// App.js
import { useEffect, useState, useCallback, useMemo } from "react";
import React from 'react';
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { Typography, Box, Grid, IconButton, Tooltip, Modal, ModalDialog, ModalClose, DialogTitle, Divider, DialogContent, DialogActions, ThemeProvider, CssBaseline, Chip, Input } from "@mui/joy";
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import DeleteAlert from "./widgets/DeleteAlert";
import { Snackbar } from "@mui/joy";
import { Button } from "@mui/joy";
import { useNavigate } from 'react-router-dom'
import {
    deleteInvoice,
    createInvoices,
    regenerateInvoicesRequest,
    updateInvoicesPaymentStatusRequest,
    bulkSendInvoicesWhatsappMessage,
    isInvoiceDeleteBlocked,
    getInvoiceDeleteErrorMessage,
} from "../../main/API/invoices";
import CustomTextField from "../../main/widgets/CustomTextField";
import CustomerOptionList from "../../main/widgets/CustomersOptionList";
import { DataGrid } from "@mui/x-data-grid";
import { Add, Delete as DeleteIcon, Edit, Receipt } from "@mui/icons-material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { apiURL } from "../../main/API/constants";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import PaymentStatusOptionList, { getPaymentStatusIconConfig } from "../../main/widgets/PaymentStatusOptionList";
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import PaymentMethodOptionList from "../../main/widgets/PaymentMethodOptionList";
import { addInvoicePayment } from "../../main/API/payment";
import { isPositivePaymentAmount } from "../../main/constants/paymentMethods";
import AccountOptionList from "../../main/widgets/AccountOptionList";
import { theme } from "../../main/theme/constants";
// import { useAuth } from "../../main/context/AuthContext";
import PermissionGate from "../../main/components/PermissionGate";
import { PERMISSIONS } from "../../main/context/AuthContext";
import { usePermissions } from "../../main/hooks/usePermissions";
import ShipmentInvoice from "../../shipments_manager/views/shipment_invoice_screen";
import { shipmentTotal } from "../../shipments_manager/views/htmlDocumentUtils";
import OmrSymbol from "../../main/components/OmrSymbol";
import { OmrAmount } from "../../main/components/OmrAmount";
import NativeCheckbox from "../../main/components/NativeCheckbox";
import { dataGridNativeCheckboxSlots } from "../../main/components/dataGridNativeCheckboxSlots";
import {
  getInvoiceGenerationNotification,
  getInvoiceGenerationErrorMessage,
} from "../../main/utils/invoiceGenerationResponse";
import CopyPaymentLinkButton from "./widgets/CopyPaymentLinkButton";
import { buildPublicInvoicePayUrl } from "../../main/utils/publicInvoicePayUrl";
import {
  getCheckoutTitle,
  getPendingCheckouts,
  sumCheckoutAmounts,
} from "../../main/utils/invoiceCheckouts";
import { getDocLocale } from "../../shipments_manager/views/htmlDocumentUtils";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

/** Parse sent count from bulk WhatsApp API body (or English "N message(s) sent"). */
function getBulkWhatsappSentCount(data, fallback) {
    if (data && typeof data === "object") {
        const candidates = [data.count, data.sent_count, data.messages_sent, data.message_count];
        for (const value of candidates) {
            const n = Number(value);
            if (value != null && !Number.isNaN(n)) return n;
        }
        const raw = typeof data.message === "string" ? data.message.trim() : "";
        const match = raw.match(/(\d+)\s+messages?\s+sent/i);
        if (match) return Number(match[1]);
    }
    return Number(fallback) || 0;
}

export default function InvoiceManagerScreen() { // Changed from ServiceManagerScreen
    // const { } = useAuth();
    const { t, i18n } = useTranslation('ui');
    const { hasPermission } = usePermissions();
    const docLocale = getDocLocale(i18n.language);

    const [paymentStatus, setPaymentStatus] = useState(null);
    const [note, setNote] = useState(null);
    const [shipmentId, setShipmentId] = useState(null);
    const [data, setData] = useState([]);
    const [results, setResults] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(false); // Changed from selectedService
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [successDelete, setSuccessDelete] = useState(false);
    const [failedDelete, setFailedDelete] = useState(false);
    const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(null);
    const [invoiceOwner, setInvoiceOwner] = useState(null);
    const [selectionModel, setSelectionModel] = useState([]);







    //generate invoices variables
    const [, setCreatedInvoicesCount] = useState(0);
    const [responseMessage, setResponseMessage] = useState("");
    const [sendInvoicesMessages, setSendInvoicesMessages] = useState(true);
    const [successNotification, setSuccessNotification] = useState(false);
    const [failedNotification, setFailedNotification] = useState(false);
    const [warningNotification, setWarningNotification] = useState(false);
    const [isGeneratingInvoicesLoading, setGeneratingInvoicesLoading] = useState(false);
    const [isRegeneratingInvoicesLoading, setRegeneratingInvoicesLoading] = useState(false);

    const [openSendMessageAlert, setOpenSendMessageAlert] = useState(false);
    const [bulkSendInvoicesWhatsappMessageLoading, setBulkSendInvoicesWhatsappMessageLoading] = useState(false);

    const [openCreateInvoicesAlert, setOpenCreateInvoicesAlert] = useState(false);
    const [openRegenerateInvoicesAlert, setOpenRegenerateInvoicesAlert] = useState(false);
    const [openUpdatePaymentStatusAlert, setOpenUpdatePaymentStatusAlert] = useState(false);
    const [isUpdatingPaymentStatus, setIsUpdatingPaymentStatus] = useState(false);
    const [pdfInvoice, setPdfInvoice] = useState(null);



    //Pay Shipments variables
    const [isPayShipmentLoading, setIsPayShipmentLoading] = useState(false);
    const [openPayShipmentsAlert, setOpenPayShipmentsAlert] = useState(false);
    const [totalAmount, setTotalAmount] = useState("");
    const [transactionReference, setTransactionReference] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [account, setAccount] = useState(null);
    // Use useMemo to calculate initial date only once - use YYYY-MM-DD format for date input
    const initialDate = useMemo(() => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }, []);
    const [transactionDate, setTransactionDate] = useState(initialDate);
    /** Selected pending checkout ids for cash/transfer (multi-select). */
    const [selectedCheckoutIds, setSelectedCheckoutIds] = useState([]);






    //table payment status icon (colors from PaymentStatusOptionList)
    function paymentStatusIcon(paymentStatus) {
        const config = getPaymentStatusIconConfig(paymentStatus);
        return (
            <Tooltip title={config.title}>
                <MonetizationOnIcon
                    color={config.color === 'success' ? 'success' : undefined}
                    sx={config.color !== 'success' ? { color: config.color } : undefined}
                />
            </Tooltip>
        );
    }

    const columns = useMemo(() => [
        { field: 'id', headerName: t('invoiceManager.colInvoiceId'), flex: 1, minWidth: 100 },
        {
            field: 'customer',
            headerName: t('invoiceManager.colCustomer'),
            flex: 3,
            minWidth: 200,
            renderCell: (params) => `${params.row.customer.first_name} ${params.row.customer.last_name == null ? " " : params.row.customer.last_name}`
        },
        {
            field: 'shipments',
            headerName: t('invoiceManager.colShipments'),
            flex: 3,
            minWidth: 200,
            renderCell: (params) => (
                <Box>
                    <Grid container spacing={0.5} sx={{ width: '100%' }}>
                        {params.row.shipments.map(shipment => (
                            <Grid item key={shipment.id}>
                                <Chip
                                    variant="soft"
                                    size="sm"
                                    sx={{
                                        borderRadius: '4px',
                                        fontSize: '0.75rem'
                                    }}
                                >
                                    #{shipment.id}
                                </Chip>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )
        },
        {
            field: 'total_price',
            headerName: t('invoiceManager.colTotalPrice'),
            flex: 1.5,
            minWidth: 120,
            valueGetter: (params) => shipmentTotal(params.row?.shipments),
            renderCell: (params) => {
                const total = shipmentTotal(params.row.shipments);
                return total > 0 ? <OmrAmount value={total} /> : null;
            },
        },
        {
            field: 'amount_paid',
            headerName: t('invoiceManager.colAmountPaid'),
            flex: 1.2,
            minWidth: 110,
            renderCell: (params) => (
                params.row.amount_paid != null ? <OmrAmount value={params.row.amount_paid} /> : null
            ),
        },
        {
            field: 'amount_due',
            headerName: t('invoiceManager.colAmountDue'),
            flex: 1.2,
            minWidth: 110,
            renderCell: (params) => (
                params.row.amount_due != null ? <OmrAmount value={params.row.amount_due} /> : null
            ),
        },

        { field: 'note', headerName: t('invoiceManager.colNote'), flex: 2, minWidth: 150 },
        { field: 'receiver_name', headerName: t('customer.receiverName'), flex: 2, minWidth: 150 },
        { field: 'receiver_civil_id', headerName: t('invoiceManager.colReceiverIdCard'), flex: 2, minWidth: 150 },
        {
            field: 'payment_link',
            headerName: t('invoiceManager.colPaymentLink'),
            flex: 2,
            minWidth: 120,
            renderCell: (params) => {
                const payUrl = buildPublicInvoicePayUrl(params.row.payment_access_token);
                return payUrl ? (
                    <CopyPaymentLinkButton
                        paymentLink={payUrl}
                        tooltip={t('invoiceManager.tooltipCopyPaymentLink')}
                    />
                ) : null;
            }
        },
        { field: 'payment_status', headerName: t('widgets.paymentStatus'), flex: 1.5, minWidth: 120, renderCell: (params) => paymentStatusIcon(params.row.payment_status) },
        {
            field: 'actions',
            headerName: t('trackingEvent.colActions'),
            sortable: false,
            flex: 2,
            minWidth: 160,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <PermissionGate permission={PERMISSIONS.INVOICES_VIEW}>
                      <Tooltip title={t('invoiceManager.tooltipInvoicePdf')}>
                          <IconButton
                              size="sm"
                              variant="soft"
                              color="neutral"
                              onClick={(e) => {
                                  e.stopPropagation();
                                  setPdfInvoice(params.row);
                              }}
                          >
                              <PictureAsPdfIcon fontSize="small" />
                          </IconButton>
                      </Tooltip>
                    </PermissionGate>
                    <PermissionGate permission={PERMISSIONS.INVOICES_UPDATE}>
                      <Tooltip title={t('invoiceManager.tooltipEditInvoice')}>
                          <IconButton
                              size="sm"
                              variant="soft"
                              color="primary"
                              onClick={(e) => {
                                  e.stopPropagation();
                                  window.open(`Invoices/${params.row.id}/EditInvoice`, '_blank');
                              }}
                          >
                              <Edit fontSize="small" />
                          </IconButton>
                      </Tooltip>
                    </PermissionGate>
                    <PermissionGate permission={PERMISSIONS.INVOICES_DELETE}>
                      {(() => {
                          const deleteBlocked = isInvoiceDeleteBlocked(params.row);
                          return (
                            <Tooltip title={deleteBlocked
                              ? t('invoiceManager.deleteBlockedByPayments')
                              : t('invoiceManager.tooltipDeleteInvoice')}>
                                <span>
                                  <IconButton
                                      size="sm"
                                      variant="soft"
                                      color="danger"
                                      disabled={deleteBlocked}
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          if (isInvoiceDeleteBlocked(params.row)) {
                                              setDeleteErrorMsg(t('invoiceManager.deleteBlockedByPayments'));
                                              setFailedDelete(true);
                                              return;
                                          }
                                          setSelectedInvoice(params.row);
                                          setDeleteAlert(true);
                                      }}
                                  >
                                      <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </span>
                            </Tooltip>
                          );
                      })()}
                    </PermissionGate>
                </Box>
            ),
        },
    ], [t]);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
    });

    const handlePageSizeChange = (pageSize) => {
        setPaginationModel({ page: 0, pageSize });
    };

    const handlePageChange = (page) => {
        setPaginationModel((prev) => ({ ...prev, page }));
    };

    const navigate = useNavigate();

    const deleteInvoiceFromTable = async (invoice) => {
        if (!hasPermission(PERMISSIONS.INVOICES_DELETE)) return;
        if (isInvoiceDeleteBlocked(invoice)) {
            setDeleteErrorMsg(t('invoiceManager.deleteBlockedByPayments'));
            setFailedDelete(true);
            setDeleteAlert(false);
            return;
        }
        setDeleteLoading(true);
        try {
            const response = await deleteInvoice(invoice);
            if (response.status === 200 || response.status === 204) {
                const newData = results.filter(item => item.id !== invoice.id);
                setResults(newData);
                setSuccessDelete(true);
            } else {
                setFailedDelete(true);
                setDeleteErrorMsg(t('invoiceManager.deleteFailedDetail', { detail: response.data?.detail ? ` ${response.data.detail}` : '' }));
            }
        } catch (e) {
            setFailedDelete(true);
            const status = e && e.response && e.response.status;
            if (status === 400) {
                setDeleteErrorMsg(
                    getInvoiceDeleteErrorMessage(e, t('invoiceManager.deleteBlockedByPayments'))
                );
            } else {
                setDeleteErrorMsg(t('invoiceManager.deleteErrorMessage', { message: e.message }));
            }
        }
        setDeleteLoading(false);
        setDeleteAlert(false);
    };


    const fetchData = async () => {
        if (!hasPermission(PERMISSIONS.INVOICES_LIST)) {
            setResults([]);
            setData([]);
            return;
        }
        setIsLoading(true);
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
        await axios.get(`${apiURL}/api/invoices/?` // Changed from services
            + "deleted=" + "false"
            + "&customer__id=" + (invoiceOwner != null ? invoiceOwner.id : "")
            + "&id=" + (id != null ? id : "")
            + "&payment_status=" + (paymentStatus != null && paymentStatus !== "" ? paymentStatus : "")
            + "&note=" + (note != null ? note : "")
            + "&shipments__id=" + (shipmentId != null ? shipmentId : "")
            + "&page=" + (paginationModel.page + 1)
            + "&page_size=" + paginationModel.pageSize,
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            }
        )
            .then((response) => response.data)
            .then((actualData) => {
                setData(actualData);
                setResults(actualData.results);
            })
            .catch((err) => {
                console.log(err.message);
            });
        setIsLoading(false);
    };


    const showInvoiceGenerationNotification = (result) => {
        setSuccessNotification(false);
        setFailedNotification(false);
        setWarningNotification(false);
        setResponseMessage(result.message);
        if (result.type === 'success') setSuccessNotification(true);
        else if (result.type === 'warning') setWarningNotification(true);
        else setFailedNotification(true);
    };

    //generate invoices function 
    const generateInvoices = async () => {
        if (!hasPermission(PERMISSIONS.INVOICES_CREATE_BULK)) return;
        setGeneratingInvoicesLoading(true);
        try {
            const actualData = await createInvoices(sendInvoicesMessages);
            const result = getInvoiceGenerationNotification(actualData.data, t, 'bulk');
            showInvoiceGenerationNotification(result);
            setCreatedInvoicesCount((actualData.data && actualData.data.created_invoice_count) || 0);
            if (result.refresh) {
                setOpenCreateInvoicesAlert(false);
                await fetchData();
            }
        } catch (err) {
            showInvoiceGenerationNotification({
                type: 'error',
                message: getInvoiceGenerationErrorMessage(err, t),
            });
        } finally {
            setGeneratingInvoicesLoading(false);
        }
    }


    const regenerateInvoices = async () => {
        if (!hasPermission(PERMISSIONS.INVOICES_REGENERATE)) return;

        setRegeneratingInvoicesLoading(true);
        try {
            const actualData = await regenerateInvoicesRequest(selectionModel, sendInvoicesMessages);
            const result = getInvoiceGenerationNotification(actualData.data, t, 'regenerate');
            showInvoiceGenerationNotification(result);
            setCreatedInvoicesCount((actualData.data && actualData.data.regenerated_invoice_count) || 0);
            if (result.refresh) {
                setOpenRegenerateInvoicesAlert(false);
                await fetchData();
            }
        } catch (err) {
            showInvoiceGenerationNotification({
                type: 'error',
                message: getInvoiceGenerationErrorMessage(err, t),
            });
        } finally {
            setRegeneratingInvoicesLoading(false);
        }
    }

    // bulk send whatsapp message for selected invoices
    const bulkSendInvoicesWhatsappMessageControl = async () => {
        if (!hasPermission(PERMISSIONS.WHATSAPP_BULK_SEND_INVOICES)) return;

        setBulkSendInvoicesWhatsappMessageLoading(true);
        await bulkSendInvoicesWhatsappMessage(selectionModel)
            .then(async actualData => {
                if (actualData.status == 200) {
                    setResponseMessage(t('invoiceManager.whatsappMessagesSent', {
                        count: getBulkWhatsappSentCount(actualData.data, selectionModel.length),
                    }));
                    setSuccessNotification(true);
                    setOpenSendMessageAlert(false);
                    await fetchData();
                } else {
                    setResponseMessage(t('invoiceManager.errorSendWhatsApp'));
                    setFailedNotification(true);
                }

                setBulkSendInvoicesWhatsappMessageLoading(false);
            }).catch((err) => {
                setBulkSendInvoicesWhatsappMessageLoading(false);
                setResponseMessage(t('invoiceManager.errorSendWhatsApp'));
                setFailedNotification(true);
                console.log(err.message);
            });
    };


    //update invoices payment status function 
    const updateInvoicesPaymentStatus = async () => {
        if (!hasPermission(PERMISSIONS.INVOICES_UPDATE_PAYMENT_STATUS)) return;
        setIsUpdatingPaymentStatus(true);
        await updateInvoicesPaymentStatusRequest(selectionModel)
            .then(async actualData => {
                //control success
                if (actualData.status == 200) {
                    setResponseMessage(t('invoiceManager.invoicesUpdatedSuccess', { count: actualData.data.updated_invoice_count }));
                    //send notification
                    setSuccessNotification(true);
                    setOpenUpdatePaymentStatusAlert(false);
                    //fetch invoices again
                    await fetchData();


                }
                //control other responses
                else {
                    setResponseMessage(t('invoiceManager.errorUpdatePaymentStatus'));
                    //send notification
                    setFailedNotification(true);
                }
                setCreatedInvoicesCount(actualData.data.regenerated_invoice_count);

                //stop loading 
                setIsUpdatingPaymentStatus(false);
            }).catch((err) => {

                //stop loading 
                setIsUpdatingPaymentStatus(false);
                console.log(err.message);
            });

    }

    // Function to reset form fields of receiver info
    const resetFields = useCallback(() => {
        setIsPayShipmentLoading(false);
        setOpenPayShipmentsAlert(false);
        setTotalAmount("");
        setTransactionReference("");
        setPaymentMethod("");
        setAccount(null);
        setTransactionDate(initialDate);
        setSelectedCheckoutIds([]);
    }, [initialDate]);

    const payTargetInvoice = useMemo(() => {
        if (selectionModel.length !== 1) return null;
        const id = selectionModel[0];
        return (results || []).find((r) => r && r.id === id) || null;
    }, [selectionModel, results]);

    const pendingPayCheckouts = useMemo(
        () => getPendingCheckouts(payTargetInvoice),
        [payTargetInvoice]
    );

    const openPayInvoiceModal = useCallback(() => {
        setSelectedCheckoutIds([]);
        setTotalAmount("");
        setOpenPayShipmentsAlert(true);
    }, []);

    const toggleCheckoutSelection = useCallback((checkoutId, checked) => {
        setSelectedCheckoutIds((prev) => {
            const id = Number(checkoutId);
            let next;
            if (checked) {
                next = prev.includes(id) ? prev : [...prev, id];
            } else {
                next = prev.filter((x) => x !== id);
            }
            setTotalAmount(sumCheckoutAmounts(next, pendingPayCheckouts));
            return next;
        });
    }, [pendingPayCheckouts]);

    const selectAllPendingCheckouts = useCallback(() => {
        const ids = pendingPayCheckouts.map((c) => Number(c.id));
        setSelectedCheckoutIds(ids);
        setTotalAmount(sumCheckoutAmounts(ids, pendingPayCheckouts));
    }, [pendingPayCheckouts]);

    const handleInvoicePayment = useCallback(async () => {
        if (!hasPermission(PERMISSIONS.PAYMENTS_ADD_INVOICE)) return;
        // Validation: Check if required fields are filled
        if (!account) {
            setResponseMessage(t('invoiceManager.accountRequired'));
            setFailedNotification(true);
            return;
        }
        if (!transactionDate) {
            setResponseMessage(t('invoiceManager.transactionDateRequired'));
            setFailedNotification(true);
            return;
        }
        if (!isPositivePaymentAmount(totalAmount)) {
            setResponseMessage(t('invoiceManager.paymentAmountPositive'));
            setFailedNotification(true);
            return;
        }

        if (pendingPayCheckouts.length >= 2 && selectedCheckoutIds.length === 0) {
            setResponseMessage(t('invoiceManager.checkoutSelectionRequired'));
            setFailedNotification(true);
            return;
        }

        // Collect data - transactionDate is already in YYYY-MM-DD format
        const payload = {
            'invoice_ids': selectionModel,
            'payment_data': {
                'total_amount': totalAmount,
                'transaction_reference': transactionReference,
                'payment_method': paymentMethod,
                'account': account.id,
                'transaction_date': transactionDate || ''
            }
        };
        if (selectedCheckoutIds.length > 0) {
            payload.invoice_checkout_ids = selectedCheckoutIds;
        }

        try {
            const response = await addInvoicePayment(payload);
            if (response.status === 200) {
                setResponseMessage(t('invoiceManager.paymentProcessedSuccess'));
                setSuccessNotification(true);
                setOpenPayShipmentsAlert(false);
                resetFields();
                await fetchData();
            } else {
                setResponseMessage(t('invoiceManager.paymentProcessFailed'));
                setFailedNotification(true);
            }
        } catch (error) {
            const apiMsg =
                error?.response?.data?.message
                || error?.response?.data?.detail
                || error?.response?.data?.invoice_checkout_ids
                || error.message;
            setResponseMessage(t('invoiceManager.paymentError', {
                message: Array.isArray(apiMsg) ? apiMsg.join(' ') : String(apiMsg || ''),
            }));
            setFailedNotification(true);
        }
    }, [
        account,
        transactionDate,
        selectionModel,
        totalAmount,
        transactionReference,
        paymentMethod,
        resetFields,
        fetchData,
        t,
        hasPermission,
        pendingPayCheckouts.length,
        selectedCheckoutIds,
    ]);







    //submit form 
    const handleSubmit = async (event) => {
        event.preventDefault();
        fetchData(true);
    }

    useEffect(() => {
        fetchData();
    }, [paginationModel.page, paginationModel.pageSize]);
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <form onSubmit={handleSubmit}>
                <Box sx={{ display: 'flex' }} m={3}>
                    <Box width={"100%"}>
                        <Box>
                            <Breadcrumbs separator={<KeyboardArrowRight />} aria-label="breadcrumbs">
                                <Link color="neutral" href="/invoices">{t('nav.invoices')}</Link>
                                <Link color="neutral" href="/invoices">{t('invoiceManager.breadcrumbManager')}</Link>
                            </Breadcrumbs>
                            <Typography textAlign={"start"} level="h1">{t('invoiceManager.pageTitle')}</Typography>
                        </Box>

                        <PermissionGate permissions={[PERMISSIONS.INVOICES_LIST]}>
                        {/* Filter Invoices field */}
                        <Grid container spacing={1} sx={{ flexGrow: 1, mb: 1 }}>
                            <Grid item xs={12}>
                                <Typography level="h3" textAlign={"start"}>{t('invoiceManager.filterHeading')}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                                <CustomTextField type="number" onChange={(e) => setId(e.target.value)} value={id} label={t('invoiceManager.labelInvoiceId')} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                                <CustomTextField type="number" onChange={(e) => setShipmentId(e.target.value)} value={shipmentId} label={t('invoiceManager.labelShipmentId')} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                                <CustomerOptionList defaultValue={invoiceOwner} onChange={(event, value) => setInvoiceOwner(value)} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                                <PaymentStatusOptionList
                                    label={t('widgets.paymentStatus')}
                                    required={false}
                                    paymentStatus={paymentStatus}
                                    showAll={true}
                                    setPaymentStatus={(newValue) => setPaymentStatus(newValue)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                                <CustomTextField type="text" onChange={(e) => setNote(e.target.value)} value={note} label={t('invoiceManager.labelNote')} />
                            </Grid>
                        </Grid>
                        <Button type="submit" loading={isLoading}>
                            {t('actions.search')}
                        </Button>
                        </PermissionGate>

                        {/* Actions icons only */}
                        <Grid mt={2} container spacing={2} justifyContent="flex-end">
                            <Grid
                                container
                                spacing={1}
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'flex-start'
                                }}
                            >
                                <PermissionGate permission={PERMISSIONS.PAYMENTS_ADD_INVOICE}>
                                    <Grid item>
                                        <Tooltip title={t('invoiceManager.tooltipPayInvoice')}>
                                            <IconButton
                                                onClick={openPayInvoiceModal}
                                                disabled={selectionModel.length !== 1}
                                                color="success"
                                                size="large"
                                                sx={{
                                                    mr: { xs: 0, md: 1 },
                                                    width: { xs: '100%', md: 'auto' },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '1.5rem'
                                                    }
                                                }}
                                            >
                                                <PriceCheckIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </PermissionGate>
                                <PermissionGate permission={PERMISSIONS.INVOICES_UPDATE_PAYMENT_STATUS}>
                                    <Grid item>
                                        <Tooltip title={t('invoiceManager.tooltipUpdatePaymentStatus')}>
                                            <IconButton
                                                onClick={() => setOpenUpdatePaymentStatusAlert(true)}
                                                disabled={selectionModel.length === 0}
                                                loading={isUpdatingPaymentStatus}
                                                color="primary"
                                                size="large"
                                                sx={{
                                                    mr: { xs: 0, md: 1 },
                                                    width: { xs: '100%', md: 'auto' },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '1.5rem'
                                                    }
                                                }}
                                            >
                                                <MonetizationOnIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </PermissionGate>
                                <PermissionGate permission={PERMISSIONS.INVOICES_REGENERATE}>
                                    <Grid item>
                                        <Tooltip title={t('invoiceManager.tooltipRegenerateInvoices')}>
                                            <IconButton
                                                onClick={() => setOpenRegenerateInvoicesAlert(true)}
                                                disabled={selectionModel.length === 0}
                                                loading={isRegeneratingInvoicesLoading}
                                                color="warning"
                                                size="large"
                                                sx={{
                                                    mr: { xs: 0, md: 1 },
                                                    width: { xs: '100%', md: 'auto' },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '1.5rem'
                                                    }
                                                }}
                                            >
                                                <RotateRightIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </PermissionGate>
                                <PermissionGate permission={PERMISSIONS.WHATSAPP_BULK_SEND_INVOICES}>
                                    <Grid item>
                                        <Tooltip title={t('invoiceManager.tooltipWhatsApp')}>
                                            <IconButton
                                                onClick={() => setOpenSendMessageAlert(true)}
                                                disabled={selectionModel.length === 0}
                                                color="success"
                                                size="large"
                                                sx={{
                                                    mr: { xs: 0, md: 1 },
                                                    width: { xs: '100%', md: 'auto' },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '1.5rem'
                                                    }
                                                }}
                                            >
                                                <WhatsAppIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </PermissionGate>
                                <PermissionGate permission={PERMISSIONS.INVOICES_CREATE_BULK}>
                                    <Grid item>
                                        <Tooltip title={t('invoiceManager.tooltipGenerateNewInvoices')}>
                                            <IconButton
                                                onClick={() => setOpenCreateInvoicesAlert(true)}
                                                loading={isGeneratingInvoicesLoading}
                                                color="primary"
                                                size="large"
                                                sx={{
                                                    mr: { xs: 0, md: 1 },
                                                    width: { xs: '100%', md: 'auto' },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '1.5rem'
                                                    }
                                                }}
                                            >
                                                <Receipt /> 
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </PermissionGate>
                                <PermissionGate permission={PERMISSIONS.INVOICES_CREATE}>
                                    <Grid item>
                                        <Tooltip title={t('invoiceManager.tooltipAddSingleInvoice')}>
                                            <IconButton
                                                onClick={() => navigate("../../Invoices/AddInvoice")}
                                                color="primary"
                                                size="large"
                                                sx={{
                                                    mr: { xs: 0, md: 1 },
                                                    width: { xs: '100%', md: 'auto' },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '1.5rem'
                                                    }
                                                }}
                                            >
                                                <Add />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </PermissionGate>
                            </Grid>
                        </Grid>

                        <PermissionGate permissions={[PERMISSIONS.INVOICES_LIST]}>
                        <Box>
                            <DataGrid
                                slots={dataGridNativeCheckboxSlots}
                                checkboxSelection
                                onRowSelectionModelChange={(newSelection) => {
                                    setSelectionModel(newSelection);
                                }}
                                selectionModel={selectionModel}
                                onPaginationModelChange={(params) => {
                                    if (params.pageSize !== paginationModel.pageSize) {
                                        handlePageSizeChange(params.pageSize);
                                    } else {
                                        handlePageChange(params.page);
                                    }
                                }}
                                pagination
                                paginationModel={paginationModel}
                                paginationMode="server"
                                rowCount={data ? data.count : 0}
                                rows={results || []}
                                columns={columns}
                                loading={isLoading}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[25, 50, 100]}
                                hideFooterSelectedRowCount
                                getRowHeight={() => 'auto'}
                                sx={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                                    '& .MuiDataGrid-root': {
                                        border: 'none',
                                    },
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#f5f5f5',
                                        borderBottom: '2px solid #e0e0e0',
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        color: '#333',
                                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                            fontWeight: 600,
                                            fontSize: '14px',
                                            color: '#333',
                                        },
                                    },
                                    '& .MuiDataGrid-cell': {
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        lineHeight: '1.5',
                                        padding: '12px 16px',
                                        fontSize: '14px',
                                        color: '#555',
                                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                                        borderBottom: '1px solid #f0f0f0',
                                    },
                                    '& .MuiDataGrid-row': {
                                        '&:hover': {
                                            backgroundColor: '#f8f9fa',
                                            cursor: 'pointer',
                                        },
                                        '&.Mui-selected': {
                                            backgroundColor: '#e3f2fd',
                                            '&:hover': {
                                                backgroundColor: '#bbdefb',
                                            },
                                        },
                                    },
                                    '& .MuiDataGrid-footerContainer': {
                                        borderTop: '2px solid #e0e0e0',
                                        backgroundColor: '#fafafa',
                                        fontSize: '14px',
                                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                                    },
                                    '& .MuiDataGrid-toolbarContainer': {
                                        padding: '12px',
                                        backgroundColor: '#fafafa',
                                        borderBottom: '1px solid #e0e0e0',
                                    },
                                    '@media (max-width: 600px)': {
                                        '& .MuiDataGrid-toolbarContainer': {
                                            flexDirection: 'column',
                                            gap: 1,
                                        },
                                        '& .MuiDataGrid-footer': {
                                            flexDirection: 'column',
                                            gap: 1,
                                        },
                                        '& .MuiDataGrid-cell': {
                                            minHeight: '60px',
                                            alignItems: 'center',
                                            padding: '8px',
                                            fontSize: '13px',
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            fontSize: '13px',
                                        },
                                    }
                                }}
                            />
                        </Box>
                        </PermissionGate>

                        <Modal open={!!pdfInvoice} onClose={() => setPdfInvoice(null)}>
                            <ModalDialog
                                sx={{
                                    maxWidth: 960,
                                    width: '100%',
                                    maxHeight: '95vh',
                                    overflow: 'auto',
                                    p: 2,
                                }}
                            >
                                <ModalClose />
                                <DialogTitle>{t('invoiceManager.invoicePdfModalTitle')}</DialogTitle>
                                <DialogContent sx={{ px: 0 }}>
                                    {pdfInvoice ? <ShipmentInvoice invoiceData={pdfInvoice} /> : null}
                                </DialogContent>
                            </ModalDialog>
                        </Modal>

                        {/* Create Invoices Alert */}
                        <Modal open={openCreateInvoicesAlert} onClose={() => setOpenCreateInvoicesAlert(false)}>
                            <ModalDialog variant="outlined" role="alertdialog">
                                <DialogTitle>
                                    <WarningRoundedIcon />
                                    {t('invoiceManager.confirmTitle')}
                                </DialogTitle>
                                <Divider />
                                <DialogContent>
                                    {t('invoiceManager.modalCreateInvoicesBody')}
                                </DialogContent>
                                <DialogContent>
                                    <NativeCheckbox defaultChecked={sendInvoicesMessages} checked={sendInvoicesMessages} onChange={(event) => setSendInvoicesMessages(event.target.checked)} label={t('invoiceManager.sendInvoicesCheckbox')} />
                                </DialogContent>
                                <DialogActions>
                                    <Button loading={isGeneratingInvoicesLoading} variant="solid" color="success" onClick={() => {
                                        generateInvoices();
                                    }}>
                                        {t('actions.yes')}
                                    </Button>
                                    <Button variant="plain" color="neutral" onClick={() => setOpenCreateInvoicesAlert(false)}>
                                        {t('actions.no')}
                                    </Button>
                                </DialogActions>
                            </ModalDialog>
                        </Modal>

                        {/* Update Payment Status Alert */}
                        <Modal open={openUpdatePaymentStatusAlert} onClose={() => !isUpdatingPaymentStatus && setOpenUpdatePaymentStatusAlert(false)}>
                            <ModalDialog variant="outlined" role="alertdialog">
                                <DialogTitle>
                                    <WarningRoundedIcon />
                                    {t('invoiceManager.confirmTitle')}
                                </DialogTitle>
                                <Divider />
                                <DialogContent>
                                    {t('invoiceManager.modalUpdatePaymentStatusBody')}
                                </DialogContent>
                                <DialogActions>
                                    <Button loading={isUpdatingPaymentStatus} variant="solid" color="success" onClick={() => {
                                        updateInvoicesPaymentStatus();
                                    }}>
                                        {t('actions.yes')}
                                    </Button>
                                    <Button variant="plain" color="neutral" disabled={isUpdatingPaymentStatus} onClick={() => setOpenUpdatePaymentStatusAlert(false)}>
                                        {t('actions.no')}
                                    </Button>
                                </DialogActions>
                            </ModalDialog>
                        </Modal>

                        {/* Regenerate Invoices Alert */}
                        <Modal open={openRegenerateInvoicesAlert} onClose={() => setOpenRegenerateInvoicesAlert(false)}>
                            <ModalDialog variant="outlined" role="alertdialog">
                                <DialogTitle>
                                    <WarningRoundedIcon />
                                    {t('invoiceManager.confirmTitle')}
                                </DialogTitle>
                                <Divider />
                                <DialogContent>
                                    {t('invoiceManager.modalRegenerateBody')}
                                </DialogContent>
                                <DialogContent>
                                    <NativeCheckbox defaultChecked={sendInvoicesMessages} checked={sendInvoicesMessages} onChange={(event) => setSendInvoicesMessages(event.target.checked)} label={t('invoiceManager.sendInvoicesCheckbox')} />
                                </DialogContent>
                                <DialogActions>
                                    <Button loading={isRegeneratingInvoicesLoading} variant="solid" color="success" onClick={() => {
                                        regenerateInvoices();
                                    }}>
                                        {t('actions.yes')}
                                    </Button>
                                    <Button variant="plain" color="neutral" onClick={() => setOpenRegenerateInvoicesAlert(false)}>
                                        {t('actions.no')}
                                    </Button>
                                </DialogActions>
                            </ModalDialog>
                        </Modal>

                        {/* Bulk send invoice WhatsApp messages */}
                        <Modal open={openSendMessageAlert} onClose={() => setOpenSendMessageAlert(false)}>
                            <ModalDialog variant="outlined" role="alertdialog">
                                <DialogTitle>
                                    <WarningRoundedIcon />
                                    {t('invoiceManager.confirmTitle')}
                                </DialogTitle>
                                <Divider />
                                <DialogContent>
                                    {t('invoiceManager.whatsappConfirmBody')}
                                </DialogContent>
                                <DialogActions>
                                    <Button loading={bulkSendInvoicesWhatsappMessageLoading} variant="solid" color="success" onClick={() => {
                                        bulkSendInvoicesWhatsappMessageControl();
                                    }}>
                                        {t('actions.yes')}
                                    </Button>
                                    <Button variant="plain" color="neutral" onClick={() => setOpenSendMessageAlert(false)}>
                                        {t('actions.no')}
                                    </Button>
                                </DialogActions>
                            </ModalDialog>
                        </Modal>

                        {/* Pay Invoices Alert */}
                        <Modal open={openPayShipmentsAlert} onClose={() => setOpenPayShipmentsAlert(false)}>
                            {/* Keep the dialog inside the viewport; the body below scrolls instead of spilling off-screen. */}
                            <ModalDialog
                                variant="outlined"
                                role="alertdialog"
                                sx={{
                                    maxWidth: 520, // dialog width cap
                                    width: '100%', // use the available width up to that cap
                                    maxHeight: '90vh', // never taller than the viewport
                                    display: 'flex', // stack title, body, and actions
                                    flexDirection: 'column',
                                    p: 0, // padding lives on the sections so the scroll area is exact
                                    overflow: 'hidden', // clip the dialog; only the body scrolls
                                }}
                            >
                                {/* Title stays visible while the fields scroll. */}
                                <DialogTitle sx={{ flexShrink: 0, px: 2.5, pt: 2.5, pb: 1 }}>
                                    <PriceCheckIcon />
                                    {t('invoiceManager.payInvoiceTitle')}
                                </DialogTitle>
                                <Divider sx={{ flexShrink: 0 }} />
                                {/* Size to the fields, then shrink so the body can scroll inside the dialog. */}
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault(); // stay on this page after submit
                                        handleInvoicePayment();
                                    }}
                                    style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', minHeight: 0 }}
                                >
                                    {/* Scroll the fields when they are taller than the dialog. */}
                                    <DialogContent
                                        sx={{
                                            flex: '1 1 auto', // grow with the fields, shrink when the viewport is short
                                            minHeight: 0, // allow this region to shrink below its content height
                                            overflowY: 'auto', // vertical scroll for the form
                                            px: 2.5,
                                            py: 2,
                                        }}
                                    >
                                        <Grid container spacing={1} sx={{ flexGrow: 1 }}>
                                            {pendingPayCheckouts.length > 0 ? (
                                                <Grid xs={12}>
                                                    <Typography level="title-sm" sx={{ mb: 0.5 }}>
                                                        {t('invoiceManager.selectCheckoutsHeading')}
                                                    </Typography>
                                                    <Typography level="body-xs" sx={{ mb: 1, color: 'neutral.600' }}>
                                                        {pendingPayCheckouts.length >= 2
                                                            ? t('invoiceManager.selectCheckoutsHintRequired')
                                                            : t('invoiceManager.selectCheckoutsHintOptional')}
                                                    </Typography>
                                                    {pendingPayCheckouts.length >= 2 ? (
                                                        <Button
                                                            size="sm"
                                                            variant="plain"
                                                            sx={{ mb: 1 }}
                                                            onClick={selectAllPendingCheckouts}
                                                        >
                                                            {t('invoiceManager.selectAllCheckouts')}
                                                        </Button>
                                                    ) : null}
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                                                        {pendingPayCheckouts.map((checkout) => (
                                                            <NativeCheckbox
                                                                key={checkout.id}
                                                                checked={selectedCheckoutIds.includes(Number(checkout.id))}
                                                                onChange={(e) =>
                                                                    toggleCheckoutSelection(checkout.id, e.target.checked)
                                                                }
                                                                label={(
                                                                    <Box component="span" sx={{ display: 'inline-flex', gap: 1, alignItems: 'baseline' }}>
                                                                        <span>{getCheckoutTitle(checkout, docLocale, t)}</span>
                                                                        <OmrAmount value={checkout.amount} />
                                                                    </Box>
                                                                )}
                                                            />
                                                        ))}
                                                    </Box>
                                                </Grid>
                                            ) : null}
                                            <CustomTextField
                                                required
                                                slotProps={{
                                                    input: {
                                                        min: 0.001,
                                                        max: 999999999999999,
                                                        step: 0.001,
                                                    },
                                                }}
                                                type="number"
                                                onChange={(event) => setTotalAmount(event.target.value)}
                                                value={totalAmount}
                                                label={t('invoiceManager.amountLabel')}
                                                endDecorator={<OmrSymbol height={16} />}
                                                xs={12}
                                                disabled={selectedCheckoutIds.length > 0}
                                            />
                                            <CustomTextField
                                                required
                                                onChange={(event) => setTransactionReference(event.target.value)}
                                                value={transactionReference}
                                                label={t('invoiceManager.transactionReferenceLabel')}
                                                xs={12}
                                            />
                                            <Grid xs={12}>
                                                <PaymentMethodOptionList
                                                    label={t('widgets.paymentMethod')}
                                                    required={true}
                                                    currentPaymentMethod={paymentMethod}
                                                    setCurrentPaymentMethod={(newValue) => setPaymentMethod(newValue)}
                                                    showAll={false}
                                                    disabled={false}
                                                />
                                            </Grid>
                                            <Grid xs={12}>
                                                <AccountOptionList
                                                    label={t('widgets.account')}
                                                    required={true}
                                                    currentAccount={account}
                                                    setCurrentAccount={(newValue) => setAccount(newValue)}
                                                    showActiveOnly={true}
                                                />
                                            </Grid>
                                            <Grid xs={12}>
                                                <Box sx={{ marginBottom: 2 }}>
                                                    <Typography
                                                        level="body-sm"
                                                        sx={{
                                                            fontWeight: 600,
                                                            color: '#555',
                                                            marginBottom: '6px',
                                                            fontSize: '14px',
                                                        }}
                                                    >
                                                        {t('invoiceManager.transactionDateLabel')}
                                                    </Typography>
                                                    <Input
                                                        type="date"
                                                        value={transactionDate}
                                                        onChange={(e) => setTransactionDate(e.target.value)}
                                                        required
                                                        sx={{
                                                            backgroundColor: '#f7f9fc',
                                                            borderRadius: '8px',
                                                            padding: '8px',
                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                            '&:hover': {
                                                                borderColor: '#5f09c2',
                                                            },
                                                            '&:focus': {
                                                                borderColor: '#5f09c2',
                                                                outline: 'none',
                                                                boxShadow: '0 0 6px rgba(0, 123, 255, 0.5)',
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </DialogContent>
                                    {/* Actions stay pinned under the scroll area. */}
                                    <Divider sx={{ flexShrink: 0 }} />
                                    <DialogActions sx={{ flexShrink: 0, px: 2.5, py: 1.5 }}>
                                        <Button loading={isPayShipmentLoading} type="submit" variant="solid" color="success">
                                            {t('actions.submit')}
                                        </Button>
                                        <Button variant="plain" color="neutral" onClick={() => {
                                            setOpenPayShipmentsAlert(false);
                                            resetFields();
                                        }}>
                                            {t('actions.cancel')}
                                        </Button>
                                    </DialogActions>
                                </form>
                            </ModalDialog>
                        </Modal>

                        <DeleteAlert
                            open={deleteAlert}
                            onDelete={() => deleteInvoiceFromTable(selectedInvoice)}
                            onClose={() => setDeleteAlert(false)}
                            loading={deleteLoading}
                        />

                        <Snackbar
                            autoHideDuration={3000}
                            open={successDelete}
                            variant={"soft"}
                            color={"success"}
                            onClose={(event, reason) => {
                                if (reason === 'clickaway') return;
                                setSuccessDelete(false);
                            }}
                        >
                            {t('invoiceManager.deletedSuccess')}
                        </Snackbar>

                        <Snackbar
                            autoHideDuration={6000}
                            open={failedDelete}
                            variant={"soft"}
                            color={"danger"}
                            onClose={(event, reason) => {
                                if (reason === 'clickaway') return;
                                setFailedDelete(false);
                            }}
                        >
                            {deleteErrorMsg}
                        </Snackbar>

                        <Snackbar
                            autoHideDuration={3000}
                            open={successNotification}
                            variant={"soft"}
                            color={"success"}
                            onClose={(event, reason) => {
                                if (reason === 'clickaway') return;
                                setSuccessNotification(false);
                            }}
                        >
                            <Box sx={{ whiteSpace: 'pre-line' }}>{responseMessage}</Box>
                        </Snackbar>

                        <Snackbar
                            autoHideDuration={8000}
                            open={warningNotification}
                            variant={"soft"}
                            color={"warning"}
                            onClose={(event, reason) => {
                                if (reason === 'clickaway') return;
                                setWarningNotification(false);
                            }}
                        >
                            <Box sx={{ whiteSpace: 'pre-line' }}>{responseMessage}</Box>
                        </Snackbar>

                        <Snackbar
                            autoHideDuration={6000}
                            open={failedNotification}
                            variant={"soft"}
                            color={"danger"}
                            onClose={(event, reason) => {
                                if (reason === 'clickaway') return;
                                setFailedNotification(false);
                            }}
                        >
                            <Box sx={{ whiteSpace: 'pre-line' }}>{responseMessage}</Box>
                        </Snackbar>

                    </Box>
                </Box>
            </form>
        </ThemeProvider>
    )
}
